/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DocumentResponse } from './DocumentResponse';
import {
    DocumentResponseFromJSON,
    DocumentResponseFromJSONTyped,
    DocumentResponseToJSON,
} from './DocumentResponse';

/**
 * 
 * @export
 * @interface DocumentUploadResponse
 */
export interface DocumentUploadResponse {
    /**
     * 
     * @type {string}
     * @memberof DocumentUploadResponse
     */
    message: string;
    /**
     * 
     * @type {DocumentResponse}
     * @memberof DocumentUploadResponse
     */
    document: DocumentResponse;
}

/**
 * Check if a given object implements the DocumentUploadResponse interface.
 */
export function instanceOfDocumentUploadResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "document" in value;

    return isInstance;
}

export function DocumentUploadResponseFromJSON(json: any): DocumentUploadResponse {
    return DocumentUploadResponseFromJSONTyped(json, false);
}

export function DocumentUploadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentUploadResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'document': DocumentResponseFromJSON(json['document']),
    };
}

export function DocumentUploadResponseToJSON(value?: DocumentUploadResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'document': DocumentResponseToJSON(value.document),
    };
}

